import queryString from 'query-string';

export function isBrowser() {
  return !(typeof window === 'undefined');
}

export function isMobile() {
  if (isBrowser()) {
    return window.innerWidth < 992;
  }

  return false;
}

export function parseURLParams(asPath = '', baseHref = '', record = null) {
  const extra = process.env.NODE_ENV === 'production' ? '.html' : '';
  const parsed = queryString.parse(queryString.extract(asPath));

  if (record) {
    Object.keys(record).forEach((key) => {
      if (record[key]) {
        parsed[key] = record[key];
      } else {
        delete parsed[key];
      }
    });
  }

  const str = queryString.stringify(parsed);

  if (!str || str.length === 0) {
    return `${baseHref}${extra}`;
  }

  return `${baseHref}${extra}?${str}`;
}

/**
 *
 * @template T
 * @param {T} productionValue
 * @param {T} developValue
 * @returns {T}
 */
export function getEnvAwareValue(productionValue, developValue) {
  if (process.env.NODE_ENV === 'development') {
    return developValue;
  }

  return productionValue;
}

export function wait(ms = 100) {
  // eslint-disable-next-line no-undef
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function devLog(...args) {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
}

export function devError(...args) {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
}
